/**
 * 全局指令
 */
import Vue from 'vue';

// 给组件库中的组件加上特定class，从而控制其主题色
Vue.directive('theme', {
    bind(el, binding, vnode) {
        const { arg } = binding;
        if (!arg) return;
        const { componentOptions: { tag } = {} } = vnode;
        el.classList.add(`${tag}-theme-${arg}`);
    },
});
